export const DATA_EDIT_LIST_DATA = 'DATA_EDIT_LIST_DATA'
export const DATA_EDIT_PUSH_TARGET = 'DATA_EDIT_PUSH_TARGET'



// WEBPACK FOOTER //
// ./src/vuex/modules/data-edit/mutation-types.js